'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSideEffect = undefined;

var _utils = require('./utils');

/**
 * Creates array describing Side Effect, where first element is Function to be executed and rest are Function arguments
 *
 * @param {Function} Side Effect implementation
 * @param {...args} Side Effect arguments
 *
 * @return {Array} Side Effect Array
 */

exports.default = function (fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  (0, _utils.invariant)(fn && (0, _utils.isFunction)(fn), 'First Side Effect argument is always function');

  return [fn].concat(args);
};

/**
 * Checks whether provided argument is Side Effect
 *
 * @param {Any} Anything
 *
 * @return {Bool} Check result
 */


var isSideEffect = exports.isSideEffect = function isSideEffect(any) {
  return Array.isArray(any) && any.length > 0 && (0, _utils.isFunction)(any[0]);
};